(function () {
    'use strict';

    var GA_ID = 'G-S5Y9SJWN3D';

    function loadGtag() {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', GA_ID);

        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
        document.head.appendChild(s);
    }

    function shouldSkipForChina(traceText) {
        return /\bloc=CN\b/.test(traceText || '');
    }

    function shouldSkipForChineseBrowser() {
        var langs = navigator.languages || [navigator.language || ''];
        for (var i = 0; i < langs.length; i++) {
            if (/^zh/i.test(langs[i])) {
                return true;
            }
        }
        return false;
    }

    if (shouldSkipForChineseBrowser()) {
        return;
    }

    fetch('https://www.cloudflare.com/cdn-cgi/trace', { cache: 'no-store' })
        .then(function (res) {
            return res.text();
        })
        .then(function (text) {
            if (!shouldSkipForChina(text)) {
                loadGtag();
            }
        })
        .catch(function () {
            loadGtag();
        });
})();
